import { X } from "lucide-react";
import type * as React from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

interface DataTableFloatingBarProps extends React.ComponentProps<"div"> {
  selectedCount: number;
  onClear: () => void;
}

export function DataTableFloatingBar({
  selectedCount,
  onClear,
  children,
  className,
  ...props
}: DataTableFloatingBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-2 z-50 flex justify-center px-2 sm:bottom-4 sm:px-4">
      <div
        role="group"
        aria-label={`Bulk actions for ${selectedCount} selected ${selectedCount === 1 ? "row" : "rows"}`}
        className={cn(
          "pointer-events-auto relative flex max-h-[calc(100vh-1rem)] w-fit max-w-[calc(100vw-1rem)] flex-wrap items-center justify-center gap-1.5 overflow-y-auto rounded-xl border bg-background p-1 shadow-xl sm:max-w-[calc(100vw-2rem)]",
          className,
        )}
        {...props}
      >
        <span className="rounded-md border bg-muted/60 px-2.5 py-1 text-sm font-medium whitespace-nowrap">
          {m.table_selected_count({ count: selectedCount })}
        </span>
        {children}
        <Button
          aria-label={m.table_clear_selection()}
          variant="ghost"
          size="icon-xs"
          className="absolute top-1 right-1 sm:static sm:ml-0.5"
          onClick={onClear}
        >
          <X />
        </Button>
      </div>
    </div>
  );
}
